import { render, staticRenderFns } from "./header-notification.vue?vue&type=template&id=0bfb904e&scoped=true"
import script from "./header-notification.vue?vue&type=script&lang=js"
export * from "./header-notification.vue?vue&type=script&lang=js"
import style0 from "./header-notification.vue?vue&type=style&index=0&id=0bfb904e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb904e",
  null
  
)

export default component.exports